import Vue from 'vue';
import Router from 'vue-router';

import login from '../components/user/login';
import register from '../components/user/register';
import home from '../components/home';

import routerBaseCode from '../router/basecode-router';
import routerBaseInfo from '../router/baseinfo-router';
import routerSys from '../router/sys-router';
import routerBill from '../router/bill-router';
import routerReports from '../router/reports-router';

Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location)
        .catch(err => err)
}

export default new Router({
    routes: [
        {
            path: "/",
            redirect: "/login"
        },
        
        {
            path: "/login",
            name: "login",
            component: login
        },
        
        {
            path: "/register",
            name: "register",
            component: register
        },
        
        {
            path: "/home",
            name: "home",
            component: home,
            children: [
                //路由文件在这里添加进去
                ...routerBaseInfo,
                ...routerBaseCode,
                ...routerSys,
                ...routerBill,
                ...routerReports
            ]
        },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js